import type { IBadgeProps } from '../../../interfaces/globals';

import './Badge.scss';

const Badge = ({ variant = 'neutral', icon, className, children }: IBadgeProps) => {
  const wrapperClasses = ['badge', `badge--${variant}`, className].filter(Boolean).join(' ');
  return (
    <span className={wrapperClasses}>
      {icon && <span className="badge__icon">{icon}</span>}
      {children}
    </span>
  );
};

export default Badge;
